module.exports = __webpack_public_path__ + "static/media/user-profile.d1bbd775.svg";